import { BaseIdNotRequiredRequest } from "../../../../base/request/BaseIdNotRequiredRequest";
import { toISODate } from "../../../../utils/fechaUtils";
import { CompraAnimalesResponse } from "../response/CompraAnimalesResponse";

/** Request de creación/edición de una compra de animales (`POST .../save`).
 *  `id` null = crear, con valor = editar. Constructor privado: se crea con
 *  {@link CompraAnimalesRequest.createEmptyRequest}. */
export type CompraAnimalesRequest = BaseIdNotRequiredRequest & {
  /** Id de la finca de la compra. */
  fincaId: string;
  /** Id del lote por el que ingresan los animales. */
  loteEntradaId: string;
  /** Id del tipo de animal. */
  tipoAnimalId: string;
  /** Id de la raza del animal. */
  razaAnimalId: string;
  /** Fecha de la compra (ISO). */
  fechaCompra: string;
  /** Cantidad de animales comprados. */
  cantidadAnimalesCompra: number;
  /** Peso promedio de entrada por animal (kg). */
  pesoPromedioEntrada: number;
  /** Precio por kilo pagado. */
  precioKg: number;
  /** Ganancia diaria de peso esperada (g/día), o null. */
  gdpEsperadoGr: number | null;
  /** Peso objetivo de salida por animal (kg). */
  pesoTargetSalida: number;
};

export const fx_createCompraAnimalesRequestEmpty = (
  fincaId: string,
): CompraAnimalesRequest => {
  return {
    cantidadAnimalesCompra: 0,
    fechaCompra: toISODate(new Date()),
    fincaId: fincaId,
    gdpEsperadoGr: 0,
    id: null,
    loteEntradaId: "",
    pesoPromedioEntrada: 0,
    pesoTargetSalida: 0,
    precioKg: 0,
    razaAnimalId: "",
    tipoAnimalId: "",
  };
};

export const fx_createCompraAnimalesRequest = (
  response: CompraAnimalesResponse,
): CompraAnimalesRequest => {
  return {
    cantidadAnimalesCompra: response.cantidadAnimalesCompra,
    fechaCompra: response.fechaCompra,
    fincaId: response.fincaId,
    gdpEsperadoGr: response.gdpEsperadoGr,
    id: response.id,
    loteEntradaId: response.loteEntrada.id,
    pesoPromedioEntrada: response.pesoPromedioEntrada,
    pesoTargetSalida: response.pesoTargetSalida,
    precioKg: response.precioKg,
    razaAnimalId: response.razaAnimalId,
    tipoAnimalId: response.tipoAnimalId,
  };
};
